import Frame from '../Frame'
import { useTexture } from '@react-three/drei'

const WebPane = ({ position, image, rotation, showFrame, imageSize = false, transparent }) => {
  const width = 5
  const height = width * (9 / 16)
  const size = imageSize || [width, height, 1]
  const depth = 0.1
  const thickness = 0.2
  const color = 'black'
  const texture = useTexture(image) // Your image!
  return (
    <group position={position} rotation={rotation}>
      {showFrame && (
        <Frame width={width} height={height} depth={depth} thickness={thickness} color={color} />
      )}
      <mesh scale={size}>
        <planeGeometry />
        <meshBasicMaterial
          map={texture}
          transparent={transparent ?? false} // ← enable alpha
          alphaTest={transparent ? 0.01 : 0}
        />
      </mesh>
    </group>
  )
}

export default WebPane
